import { render, staticRenderFns } from "./PredefinedProtocolCrud.vue?vue&type=template&id=40cbdc3f&scoped=true&"
import script from "./PredefinedProtocolCrud.vue?vue&type=script&lang=js&"
export * from "./PredefinedProtocolCrud.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedProtocolCrud.vue?vue&type=style&index=0&id=40cbdc3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cbdc3f",
  null
  
)

export default component.exports